import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'icon' | 'text' | 'label' | 'button' | 'date' | 'selected' | 'disabled' | 'first'>({
    name: 'RevisionSelect'
})((_, __, classes) => ({
    chip: {
        boxShadow: 'none !important',
        [`& .${classes.icon}`]: {
            color: '#232323',
            width: 16,
            height: 16,
            marginLeft: 6
        },
        [`& .${classes.text}`]: {
            color: '#232323',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '16px'
        },
        [`& .${classes.label}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        },
        [`& .${classes.date}`]: {
            color: '#8E8E8E',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '16px'
        },
        [`&.${classes.disabled}`]: {
            background: '#f8f8f8',
            borderColor: '#f8f8f8',
            [`& .${classes.text}`]: {
                color: '#8E8E8E'
            },
            [`& .${classes.label}`]: {
                color: '#8E8E8E'
            },
            [`& .${classes.icon}`]: {
                color: '#8E8E8E'
            }
        }
    },
    icon: {},
    text: {},
    label: {},
    date: {},
    selected: {},
    disabled: {},
    first: {},
    button: {},
    current: {
        height: 20,
        border: '1px solid #C1E8D4',
        [`& .${classes.label}`]: {
            paddingLeft: 4,
            paddingRight: 4,
            color: '#05A569',
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '16px'
        }
    },
    version: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        [`&.${classes.selected}`]: {
            fontWeight: 700
        }
    },
    menu: {
        position: 'relative',
        minWidth: 320,
        maxWidth: 380,
        maxHeight: 600,
        paddingLeft: 4,
        paddingRight: 4,
        marginTop: 4,
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    menuList: {
        paddingTop: 0
    },
    menuTitle: {
        zIndex: 100,
        paddingTop: 8,
        paddingBottom: 8,
        top: 0,
        position: 'sticky',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        paddingLeft: 12,
        paddingRight: 12
    },
    milestone: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '16px 12px 8px 12px',
        color: '#8E8E8E',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        [`&.${classes.first}`]: {
            paddingTop: 8
        }
    },
    empty: {
        paddingLeft: 12
    },
    menuItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
        position: 'relative',
        paddingLeft: 36,
        borderRadius: 8,
        border: '1px solid transparent',
        ['&:hover:not(:active)']: {
            background: 'transparent',
            border: '1px solid #ECECEC'
        },
        ['&:hover:before']: {
            top: 5,
            bottom: 4
        },
        ['&:before']: {
            content: '""',
            position: 'absolute',
            width: 1.5,
            background: '#ECECEC',
            left: 19,
            top: -1,
            bottom: -1
        }
    },
    description: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '19.5px',
        width: '100%',
        gap: 4,
        color: '#8E8E8E',
        [`& .${classes.text}`]: {
            flex: 1,
            color: '#232323',
            whiteSpace: 'nowrap',
            display: 'block',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        },
        [`& .${classes.date}`]: {
            color: '#8E8E8E'
        }
    },
    spinner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    download: {
        position: 'sticky',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 8,
        [`& .${classes.button}`]: {
            boxShadow: 'none !important',
            background: '#232323',
            color: '#fff',
            ['&:hover']: {
                background: '#2D2D2D'
            },
            ['&:active']: {
                background: '#151515'
            },
            ['&:disabled']: {
                background: '#FAFAFA',
                color: '#D3D3D3'
            }
        }
    }
}));
